import { gql } from "@apollo/client";

export const GET_ANALYTICS = gql`
  query GetAnalytics($period: String) {
    getAnalytics(period: $period) {
      totalCryptoSold {
        totalNGN
        history {
          date
          amount
        }
      }
      totalWalletWithdrawals {
        totalNGN
        history {
          date
          amount
        }
      }
      totalCryptoSoldCount {
        totalCount
        history {
          date
          amount
        }
      }
      mostTradedCoins {
        coin
        totalNGN
        totalUSD
        totalGHS
      }
      mostTradedGiftcards {
        cardName
        total
        count
      }
      favouriteBrand {
        cardName
        count
      }
      bestRateEver {
        cardName
        rate
        date
      }
      mostProfitableDay {
        date
        totalNGN
      }
    }
  }
`;
